import { render } from "./RecipePage.vue?vue&type=template&id=75fc5cf4&scoped=true"
import script from "./RecipePage.vue?vue&type=script&lang=js"
export * from "./RecipePage.vue?vue&type=script&lang=js"

import "./RecipePage.vue?vue&type=style&index=0&id=75fc5cf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fc5cf4"]])

export default __exports__